import CloseIcon from '@mui/icons-material/Close';
import { Card, CardContent, Typography, IconButton } from '@mui/material';

import { useStyles } from './style';

interface SelectedUserGroupCardProps {
	name?: string;
	handleClose?(...args: unknown[]): unknown;
}

const SelectedUserGroupCard = (props: SelectedUserGroupCardProps) => {
	const { name, handleClose } = props;

	const classes = useStyles();

	return (
		<Card className={classes.root}>
			<CardContent className={classes.content}>
				<Typography variant='h5'>{name}</Typography>
			</CardContent>
			<IconButton onClick={handleClose} size='large'>
				<CloseIcon />
			</IconButton>
		</Card>
	);
};

export default SelectedUserGroupCard;
